<template>
    <div>
      <template v-if="isEdit">
        <div class="tag-box-edit">
          <div style="display: flex;flex-direction: row;gap: 4px;align-items: center;">
            <input
              v-model="item"
              class="input-box"
              :required="true"
              type="text"
              style="height:20px"
            />
            <div @click="summitQuestion">
              <img src="/static/img/assets/welcome/correct.svg" />
            </div>
            <div @click="changeIsEdit">
              <img src="/static/img/assets/welcome/X.svg" />
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="tag-box">
          <div style="display: flex;flex-direction: row;gap: 4px;align-items: center;">
            <Typography :label="item" color="color-darkBlue"/>
            <div @click="changeIsEdit">
              <img src="/static/img/assets/welcome/pencil.svg" />
            </div>
            <div @click="removeTag">
              <img src="/static/img/assets/welcome/X.svg" />
            </div>
          </div>
        </div>
      </template>
    </div>
  </template>
  
  <script>
  import Typography from '@/components/elements/Typography'

  export default {
    data: function() {
      return {
        isEdit: false,
        value: '',
      }
    },
    components: {
      Typography
    },
    props: {
      item: String,
      index: Number,
    },
    mounted: function(){
        this.value = this.item
    },
    methods: {
      changeIsEdit: function() {
        // this.item = this.value
        this.isEdit = !this.isEdit
      },
      summitQuestion: function() {
        
        if(this.item.includes(',')){
          this.$swal.fire({
          title:'<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
          html: `<div> ไม่สามารถใช้เครื่องหมายจุลภาค (,) ในประโยคได้ กรุณาลองใหม่อีกครั้ง </div>`,
          showCancelButton: false,
          showCloseButton: true,
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
          width:'590px',
          })
          return
        }
        if(this.item.includes('(')){
          this.$swal.fire({
          title:'<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
          html: `<div> ไม่สามารถใช้เครื่องหมายวงเล็บ ( ) ในประโยคได้ กรุณาลองใหม่อีกครั้ง </div>`,
          showCancelButton: false,
          showCloseButton: true,
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
          width:'590px',
          })
          return
        }
        if(this.item.includes(')')){
          this.$swal.fire({
          title:'<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
          html: `<div> ไม่สามารถใช้เครื่องหมายวงเล็บ ( ) ในประโยคได้ กรุณาลองใหม่อีกครั้ง </div>`,
          showCancelButton: false,
          showCloseButton: true,
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
          width:'590px',
          })
          return
        }
        if(this.item === ''){
          this.$swal.fire({
          title:'<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
          html: `<div> กรุณากรอกข้อความ </div>`,
          showCancelButton: false,
          showCloseButton: true,
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
          width:'590px',
          })
          return
        }
        this.$emit('changUserTag',this.item, this.index)
        this.isEdit = false
      },    
      removeTag: function() {
        this.$emit('removieUserTag', this.index)
      },
    }
  }
  </script>
  <style scoped>
  .tag-box {
    background-color: rgba(230, 240, 251, 1);
    padding: 0px 8px 0px 8px;
    display: inline-block;
    margin-right: 8px;
    margin-bottom: 8px;
    border: 1px solid rgba(12, 47, 83, 1);
    color: rgba(12, 47, 83, 1);
    border-radius: 6px;
    min-width: 60px;
    text-align: center;
  }
  
  .input-box {
    color: rgba(12, 47, 83, 1);
    height: 20px;
  }
  .tag-box-edit {
    background-color: rgba(230, 240, 251, 1);
    padding: 0px 8px 0px 8px;
    display: inline-block;
    margin-right: 8px;
    /* margin-bottom: 8px; */
    border: 1px solid rgba(12, 47, 83, 1);
    color: rgba(12, 47, 83, 1);
    border-radius: 6px;
    min-width: 60px;
    text-align: center;
    height: 25px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/view/welcomemessage/ChatbotBoxMessage.vue